import type { AdminUserExport } from './types/types';

const CSV_MIME_TYPE = 'text/csv;charset=utf-8';
const CSV_FILE_NAME = 'users.csv';
const UTF_8_BOM = '\uFEFF';

const escapeCsvField = (value: string): string => {
  if (!/[",\r\n]/.test(value)) {
    return value;
  }

  return `"${value.replace(/"/g, '""')}"`;
};

export const createAdminUsersCsv = (users: AdminUserExport[]): string => {
  const rows = users.map(({ name, email, phone }) =>
    [name, email ?? '', phone ?? ''].map(escapeCsvField).join(',')
  );

  return `${UTF_8_BOM}${rows.join('\r\n')}`;
};

export const downloadAdminUsersCsv = (users: AdminUserExport[]): void => {
  const blob = new Blob([createAdminUsersCsv(users)], { type: CSV_MIME_TYPE });
  const objectUrl = URL.createObjectURL(blob);
  const downloadLink = document.createElement('a');

  downloadLink.href = objectUrl;
  downloadLink.download = CSV_FILE_NAME;
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);

  try {
    downloadLink.click();
  } finally {
    downloadLink.remove();
    URL.revokeObjectURL(objectUrl);
  }
};
